/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { ICancelAndAddAppointmentRequest, IUpdateAppointmentRequest } from "./appointment.interface";

import { FindAvailabilityFormType } from "../available-times/available-times.schema";
import { IAppointmentItemResponse } from "../appointment-list/appointment-list.interface";
import { ReasonForCancelFormType } from "../reason-for-cancel/reason-for-cancel.schema";

export class UpdateAppointmentRequest implements IUpdateAppointmentRequest {
  public appointmentId: string;
  public status_id: number;
  public start_at: number;
  public cancel: boolean;

  constructor(
    findAvailabilityForm: FindAvailabilityFormType,
    visitSelected: IAppointmentItemResponse,
  ) {
    this.appointmentId = visitSelected.id;
    this.status_id = 1;
    this.start_at = +findAvailabilityForm.time;
    this.cancel = false;
  }
}

// export class CancelAndAddAppointmentRequest implements ICancelAndAddAppointmentRequest {
//   public petId : string;
//   public appointmentType : number;
//   public locationId : string;
//   public appointmentId: string;
//   public start_at: number;
//   public sales_resource: number;
//   public appointmentFrom: string;
//   // public newAppointmentId: string;


//   constructor(
//     findAvailabilityForm: FindAvailabilityFormType,
//     visitSelected: IAppointmentItemResponse,
//     // updateAppointment: ICancelAndAddAppointmentRequest,
//   ) {
//     this.appointmentId = visitSelected.id;
//     this.start_at = +findAvailabilityForm.time;
//     this.petId = visitSelected.pet.id;
//     this.appointmentType = findAvailabilityForm.appointmentTypes[0].appointmentType;
//     this.locationId= visitSelected.location.idLocation;
//     this.sales_resource = +findAvailabilityForm.resourcesId;
//     this.appointmentFrom = "Web";
//     // this.newAppointmentId = updateAppointment.appointmentId;
//   }
// }

export class CancelAppointmentRequest implements IUpdateAppointmentRequest {
  public appointmentId: string;
  public status_id: number;
  public cancel: boolean;
  public cancellation_reason?: number;
  public cancellation_reason_text?: string;

  constructor(
    reasonForCancelForm: ReasonForCancelFormType,
    visitSelected: IAppointmentItemResponse,
  ) {
    this.appointmentId = visitSelected.id;
    this.status_id = 1;
    this.cancel = true;
    this.cancellation_reason = 1;
    this.cancellation_reason_text = reasonForCancelForm.other || reasonForCancelForm.reason;
  }
}
